import React from 'react';

const MapComponent = () => {
    return (
        <div style={{ width: '100%', height: '450px' }}>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1967.8301713702351!2d22.258200499999997!3d60.448019099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x468c77fb3be6871f%3A0xccda82badab305d2!2sThe%20Momo%20Cafe!5e0!3m2!1sen!2snp!4v1733839946244!5m2!1sen!2snp"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="The Momo Cafe Location"
            ></iframe>
        </div>
    );
};

export default MapComponent;
